import bfIcon from './bficon.vue';
bfIcon.install = Vue => Vue.component(bfIcon.name,bfIcon);
export default bfIcon;



// WEBPACK FOOTER //
// ./src/packages/icon/index.js